import bluePlus from "./bluePlus.svg";
import info from "./information.png";
import CancelTripModal from "./CancelTripModal/CancelTripModal";

import { applicationsData } from "./applications.data";

import deleteIcon from "../../../../../assets/icons/delete_plus.svg";
import Header from "../../../../layout/Header/Header";
import Footer from "../../../../layout/Footer/Footer";
import Breadcrumbs from "../../../../common/Breadcrumbs/Breadcrumbs";
import {
    getLocalTripsListThunk,
    cancelLocalTripThunk,
} from "../../../../../redux/actions/LocalTrips/thunk/LocalTrips.thunk.action";
import {
    clearErrorLocalTripAction,
    clearLocalTripsListAction,
} from "../../../../../redux/actions/LocalTrips/LocalTrips.action";
import ModalBanOverlay from "../../../../common/Modal/ModalBanOverlay/ModalBanOverlay";
import ErrorModal from "../../../../common/Modal/ModalConditions/Profile/ErrorModal/ErrorModal";

import "./JournalOfLocalTrips.scss";

import { RightArrow } from "../../../../../assets/icons/RightArrow";
import { LeftArrow } from "../../../../../assets/icons/LeftArrow";

import { isTerminal } from "../../../../../constants";

import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import moment from "moment";

const AddLocalTrip = ({ parentStyle }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (
        <div
            onClick={() => {
                navigate("/main/hr-services/work-time/local-trips/create");
                dispatch(clearErrorLocalTripAction());
            }}
            className={"request-delegations__add__button"}
        >
            <span>Создать командировку</span>
            <img
                className={"request-delegations__add__button__blue-plus"}
                src={bluePlus}
                alt="bluePlus"
            />
        </div>
    );
};

const JournalOfLocalTrips = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const localTripsList = useSelector(state => state.localTrips.localTripsList);
    const error = useSelector(state => state.localTrips.localTripError);

    const [statusModal, setStatusModal] = useState({
        status: false,
        loading: false,
        message: "",
        delete: false,
        trip: null,
        id: null,
    });

    // Состояние для пагинации
    const [pagination, setPagination] = useState({
        currentPage: 0, // Для ReactPaginate (начинается с 0)
        pageSize: 20,
    });

    function closeModal() {
        setStatusModal({
            status: false,
            message: "",
            loading: false,
            delete: false,
            trip: null,
            id: null,
        });
    }

    // Функция для проверки активной командировки
    function isTripActive(startsAt, endsAt) {
        const now = moment();
        const start = moment(startsAt);
        const end = moment(endsAt);
        return now.isBetween(start, end, null, "[]");
    }

    // Функция для проверки, истекло ли время на согласование
    function isApprovalDeadlinePassed(approvalDeadlineAt) {
        if (!approvalDeadlineAt) return false;
        return moment().isAfter(moment(approvalDeadlineAt));
    }

    // Функция для отмены командировки
    function cancelTripStatus(trip) {
        setStatusModal({
            ...statusModal,
            delete: true,
            loading: false,
            trip: trip,
        });
    }

    // Функция для выполнения отмены командировки
    function cancelTrip() {
        if (statusModal.trip && statusModal.trip.id) {
            setStatusModal({
                ...statusModal,
                loading: true,
                id: statusModal.trip.id,
                delete: false,
            });

            dispatch(cancelLocalTripThunk({
                id: statusModal.trip.id,
                statusModal,
                setStatusModal,
                onSuccess: () => {
                    // После успешной отмены перезагружаем текущую страницу
                    loadTrips(pagination.page, pagination.pageSize);
                },
            }));
        }
    }

    function getColor(status) {
        switch (status) {
        case "APPROVED":
            return "green";
        case "REJECTED":
            return "red";
        case "PENDING_APPROVAL":
            return "rgba(109, 205, 246, 1)";
        default:
            return "black";
        }
    }

    // Функция загрузки командировок
    const loadTrips = (pageIndex, pageSize) => {
        // pageIndex - индекс для ReactPaginate (0, 1, 2...)
        // Бэкенд ожидает номер страницы (1, 2, 3...)
        const pageNumber = pageIndex + 1;

        dispatch(getLocalTripsListThunk({
            role: "initiator",
            page: pageNumber,
            pageSize: pageSize,
            setStatusModal: setStatusModal,
            statusModal: statusModal,
        }));

        // Обновляем состояние
        setPagination(prev => ({
            ...prev,
            currentPage: pageIndex,
            pageSize: pageSize,
        }));
    };

    function changePageSize(number) {
        loadTrips(0, number); // При изменении размера страницы переходим на первую
    }

    // Обработчик изменения номера страницы
    function changePageNumber(selectedPage) {
        loadTrips(selectedPage.selected, pagination.pageSize);
    }

    useEffect(() => {
        // Загружаем первую страницу при монтировании
        loadTrips(0, pagination.pageSize);

        return () => {
            dispatch(clearErrorLocalTripAction());
            dispatch(clearLocalTripsListAction());
        };
    }, [dispatch]);

    // Получаем данные пагинации из ответа
    const paginationData = localTripsList?.pagination || {};
    const totalPages = paginationData.totalPages || 1;

    return (
        <>
            <Header />
            <Breadcrumbs />
            <div className={"journal-of-localTrips"}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                    <h3>Журнал местных командировок</h3>
                    <AddLocalTrip />
                </div>

                <table className="table">
                    <thead>
                        <tr className="table__row">
                            {applicationsData.map((el, index) => (
                                <th
                                    key={`${el.id}-${index}`}
                                    style={{ width: el.width }}
                                    className="delegation-of-responsibilities__rows__item"
                                >
                                    {el.title}
                                    {el.icon && (
                                        <img
                                            src={el.icon}
                                            alt="triangle"
                                            className="header-triangle"
                                        />
                                    )}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {localTripsList ? (
                        localTripsList.items && localTripsList.items.length > 0 ? (
                            <tbody>
                                {localTripsList.items.map((trip) => {
                                    const isActive = isTripActive(trip.startsAt, trip.endsAt);
                                    const isApprovalExpired = isApprovalDeadlinePassed(trip.approvalDeadlineAt);
                                    const canCancel = (
                                        trip.status.value === "PENDING_APPROVAL" &&
                                    !isActive &&
                                    !isApprovalExpired
                                    );

                                    return (
                                        <tr
                                            key={trip.id}
                                            className={
                                                isActive
                                                    ? "delegation-of-responsibilities__rows-active"
                                                    : "delegation-of-responsibilities__rows"
                                            }
                                        >
                                            <td style={{ width: "190px" }}>
                                                {trip.initiator?.fullName || "Не указано"}
                                            </td>
                                            <td style={{ width: "150px" }}>
                                                {trip.reason.displayName || "Не указано"}
                                            </td>
                                            <td style={{ width: "150px" }}>
                                                {moment(trip.startsAt).format("DD.MM.YYYY HH:mm")}
                                            </td>
                                            <td style={{ width: "150px" }}>
                                                {moment(trip.endsAt).format("DD.MM.YYYY HH:mm")}
                                            </td>
                                            <td style={{ width: "170px", overflowWrap: "break-word"  }}>
                                                {trip.comment || "-"}
                                            </td>
                                            <td style={{
                                                width: "100px",
                                                color: `${getColor(trip.status.value)}`,
                                                display: "flex",
                                                gap: "5px",
                                            }}>
                                                {trip.status.displayName}
                                                {trip.rejectionComment && (
                                                    <span className={"hint"}>
                                                        <img src={info} alt="#" />
                                                        <div className="custom-uploader__item__name__label">
                                                            {trip.rejectionComment}
                                                        </div>
                                                    </span>
                                                )}
                                            </td>
                                            <td style={{ width: "66px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    {canCancel ? (
                                                        <div id={trip.id}>
                                                            {statusModal.loading && statusModal.id === trip.id ? (
                                                                <ClipLoader color="#6DCDF6" size={20} />
                                                            ) : (
                                                                <img
                                                                    className="table-img"
                                                                    onClick={() => cancelTripStatus(trip)}
                                                                    src={deleteIcon}
                                                                    alt="Отменить"
                                                                    title="Отменить"
                                                                    style={{ cursor: "pointer" }}
                                                                />
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <span className="popup-notification">
                                                            <img
                                                                style={{ opacity: "30%", filter: "grayscale(100%)", cursor: "not-allowed" }}
                                                                className="table-img"
                                                                src={deleteIcon}
                                                                alt="Нельзя отменить"
                                                            />
                                                            <div className="custom-uploader__item__name__label">
                                                                {isActive
                                                                    ? "Командировка активна и не может быть отменена"
                                                                    : trip.status.value === "APPROVED"
                                                                        ? "Командировка уже согласована и не может быть отменена"
                                                                        : trip.status.value === "REJECTED"
                                                                            ? "Командировка уже отклонена"
                                                                            : isApprovalExpired
                                                                                ? "Время на согласование истекло, командировку нельзя отменить"
                                                                                : "Командировка не может быть отменена"}
                                                            </div>
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={applicationsData.length}>
                                        <div className={"replacement-modal__body"}>
                                            {error ? (
                                                <div className="error-message">
                                                Ошибка: {error.message || "Не удалось загрузить данных"}
                                                </div>
                                            ) : (
                                                <div style={{
                                                    opacity: "70%",
                                                    height: "200px",
                                                    width: "1160px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }} className={"table__row__item"}>
                                                Командировки отсутствуют
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        )
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan={applicationsData.length}>
                                    <div style={{
                                        height: "200px",
                                        width: "1160px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}>
                                        <ClipLoader color="#6DCDF6" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>

                {/* Пагинация */}
                {
                    !localTripsList?.items?.length
                        ? <div></div>
                        : <div className={isTerminal && "pagination-wrapper"}>
                            {!isTerminal && <div className="pagination-container">
                                <div className="pagination-container__rows">
                                    <div
                                        onClick={() => changePageSize(5)}
                                        className={pagination.pageSize === 5 ? "rowsPerPage-number-active" : "rowsPerPage-number-inactive"}>
                                        5
                                    </div>
                                    <div
                                        onClick={() => changePageSize(10)}
                                        className={pagination.pageSize === 10 ? "rowsPerPage-number-active" : "rowsPerPage-number-inactive"}>
                                        10
                                    </div>
                                    <div
                                        onClick={() => changePageSize(20)}
                                        className={pagination.pageSize === 20 ? "rowsPerPage-number-active" : "rowsPerPage-number-inactive"}>
                                        20
                                    </div>
                                    <div
                                        onClick={() => changePageSize(50)}
                                        className={pagination.pageSize === 50 ? "rowsPerPage-number-active" : "rowsPerPage-number-inactive"}>
                                        50
                                    </div>
                                </div>
                            </div>
                            }
                            <ReactPaginate
                                className={"pagination"}
                                breakLabel=".."
                                nextLabel={isTerminal ? <RightArrow /> : ">"}
                                onPageChange={changePageNumber}
                                pageRangeDisplayed={3}
                                pageCount={totalPages}
                                previousLabel={isTerminal ? <LeftArrow /> : "<"}
                                renderOnZeroPageCount={null}
                                forcePage={pagination.currentPage}
                            />
                        </div>
                }

            </div>

            {/* Модальные окна */}
            <ModalBanOverlay shown={statusModal.status} close={closeModal}>
                <ErrorModal
                    description={statusModal.message}
                    setError={setStatusModal}
                    funk={cancelTrip}
                    route={"/main/hr-services/work-time"}
                    okButton={"ок"}
                />
            </ModalBanOverlay>

            <ModalBanOverlay shown={statusModal.delete} close={closeModal}>
                <CancelTripModal
                    close={closeModal}
                    proceed={cancelTrip}
                    modalData={statusModal.trip}
                />
            </ModalBanOverlay>

            <Footer />
        </>
    );
};

export default JournalOfLocalTrips;
